export default {
    "SETTINGS": {
        "target": "Target date",
        "ad_url": "Middle tile url",
        "contact_email": "Form email address",
        "main_page_text": "Main page text HU",
        "main_page_text_hu": "Main page text HU",
        "main_page_text_en": "Main page text EN",
        "main_page_image": "Main page image",
        "form_fazekas": "Űrlap: Fazekastalálkozó",
        "form_vendeglatos": "Űrlap: Vendéglátósok",
        "form_maganudvar": "Űrlap: Magánudvar",
        "form_malomudvar": "Űrlap: Malomsziget",
        "form_kastelyudvar": "Űrlap: Malomsziget",
        "form_zenekar": "Űrlap: Fellépők",
        'form_egyeb': 'Űrlap: Egyéb',
        "gallery_intro_en": "Galléria intró EN",
        "gallery_intro_hu": "Galléria intró HU",
        "main_page_programs_link": "Programs Sections Link",
        "main_page_link": "Main Page Link",
        "main_page_logo": "Main Page Logo HU",
        "main_page_logo_hu": "Main Page Logo HU",
        "main_page_logo_en": "Main Page Logo EN",
        "main_page_counter_en": "Main Page Counter Text EN",
        "main_page_counter_hu": "Main PAge Counter Text HU",
        "main_page_categories_header_hu": "Main page categories header HU",
        "main_page_categories_header_en": "Main page categories header EN",
        "app_url_android": "App Url Android",
        "app_url_ios": "App Url iOS",
        'main_page_youtube_embed': 'Youtube embed id',
        'main_page_galleries_header_hu': 'Gallery header HU',
        'main_page_galleries_header_en': 'Gallery header EN',
        'main_page_tickets_header_hu': 'Tickets header HU',
        'main_page_tickets_header_en': 'Tickets header EN',
        'page_title_hu': 'Page Title HU',
        'page_title_en': 'Page Title EN',
        'page_description_hu': 'Page Description HU',
        'page_description_en': 'Page Description EN',
        'date_from': 'Date Start',
        'date_to': 'Date End',
        'social_instagram': 'Instagram link',
        'social_facebook': 'Facebook link',
        'social_youtube': 'Youtube link',
        'social_spotify': 'Spotify link',
        'webshop_title_hu': 'Webshop Title HU',
        'webshop_title_en': 'Webshop Title EN',
        'webshop_description_hu': 'Webshop Description HU',
        'webshop_description_en': 'Webshop Description EN',
        'webshop_link_text_hu': 'Webshop Link Text HU',
        'webshop_link_text_en': 'Webshop Link Text EN',
        'webshop_link': 'Webshop Link',
        'main_page_ticket_button_hu': 'Tickets button text HU',
        'main_page_ticket_button_en': 'Tickets button text EN',
        'main_page_programs_button_hu': 'Programs button text HU',
        'main_page_programs_button_en': 'Programs button text EN',
        'webshop_image': 'Webshop kép',
        'egesz-napos-programok-image': 'Full day programs mobile image',
        'most-szinpadon-image': 'Now on stage mobile image',
        'footer_follow_hu': 'Footer follow us HU',
        'footer_follow_en': 'Footer follow us EN',
        'page_subdescription_hu': 'Page subdescription HU',
        'page_subdescription_en': 'Page subdescription EN',

        // Main page 2027 contents
        'main_page_eyebrow_hu': 'Main title eyebrow HU',
        'main_page_eyebrow_en': 'Main title eyebrow EN',
        'main_page_featured_artists_eyebrow_hu': 'Featured artists eyebrow HU',
        'main_page_featured_artists_eyebrow_en': 'Featured artists eyebrow EN',
        'main_page_featured_artists_title_hu': 'Featured artists title HU',
        'main_page_featured_artists_title_en': 'Featured artists title EN',
        'main_page_program_categories_title_hu': 'Program categories title HU',
        'main_page_program_categories_title_en': 'Program categories title EN',
        'main_page_video_eyebrow_hu': 'Video section eyebrow HU',
        'main_page_video_eyebrow_en': 'Video section eyebrow EN',
        'main_page_video_title_hu': 'Video section title HU',
        'main_page_video_title_en': 'Video section title EN',
        'main_page_video_text_hu': 'Video section text HU',
        'main_page_video_text_en': 'Video section text EN',
        'main_page_gallery_title_hu': 'Gallery section title HU',
        'main_page_gallery_title_en': 'Gallery section title EN',
        'main_page_description_eyebrow_hu': 'Description section eyebrow HU',
        'main_page_description_eyebrow_en': 'Description section eyebrow EN',
        'main_page_description_title_hu': 'Description section title HU',
        'main_page_description_title_en': 'Description section title EN',
        'main_page_description_text_hu': 'Description section text HU',
        'main_page_description_text_en': 'Description section text EN',
        'main_page_description_content_hu': 'Description content (title + text) HU',
        'main_page_description_content_en': 'Description content (title + text) EN',
        'main_page_webshop_title_hu': 'Webshop section title HU',
        'main_page_webshop_title_en': 'Webshop section title EN',
        'main_page_webshop_text_hu': 'Webshop section text HU',
        'main_page_webshop_text_en': 'Webshop section text EN',
        'main_page_subscription_title_hu': 'Subscription section title HU',
        'main_page_subscription_title_en': 'Subscription section title EN',
        'main_page_subscription_text_hu': 'Subscription section text HU',
        'main_page_subscription_text_en': 'Subscription section text EN',
        'main_page_news_title_hu': 'News section title HU',
        'main_page_news_title_en': 'News section title EN',
        'main_page_faq_title_hu': 'FAQ section title HU',
        'main_page_faq_title_en': 'FAQ section title EN',
        'main_page_map_title_hu': 'Map section title HU',
        'main_page_map_title_en': 'Map section title EN',

        'main_page_shop_images_en': 'Webshop section images EN',
        'main_page_shop_images_hu': 'Webshop section images HU',

        // Webshop eyebrow (Settings)
        'webshop_eyebrow_hu': 'Webshop eyebrow HU',
        'webshop_eyebrow_en': 'Webshop eyebrow EN',
    }
}



// WEBPACK FOOTER //
// ./src/i18n/messages/en/settings.js